import React from 'react'

const Bulletlist = () => {
    return (
        <svg className='bulleted-list' id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 334.48 241.38">
            <rect className="cls-1" x="79.31" y="17.24" width="255.17" height="17.24" />
            <circle className="cls-1" cx="25.86" cy="25.86" r="25.86" />
            <rect className="cls-1" x="79.31" y="112.07" width="255.17" height="17.24" />
            <circle className="cls-1" cx="25.86" cy="120.69" r="25.86" />
            <rect className="cls-1" x="79.31" y="206.9" width="255.17" height="17.24" />
            <circle className="cls-1" cx="25.86" cy="215.52" r="25.86" />
        </svg>
    )
}

export default Bulletlist